export const HISTORY_FAULT_CARD_DEFAULT_TEMPLATE = {
  op: 'ui',
  name: 'ExpandableCard',
  unmountOnExit: true,
  'data-testid': {
    op: 'array-join',
    value: [
      'fault-card-',
      {
        op: 'context',
        path: 'item.event.eventId',
      },
    ],
    separator: '',
  },
  summary: {
    op: 'ui',
    name: 'Stack',
    direction: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    spacing: 1,
    children: [{
      op: 'ui',
      name: 'Stack',
      flex: '1 0 45%',
      children: [
        {
          op: 'if',
          condition: {
            op: 'ne', a: { op: 'context', path: 'item.event.data.type' }, b: 'Hino',
          },
          then: {
            op: 'ui',
            name: 'Stack',
            direction: 'row',
            width: '100%',
            gap: 1,
            alignItems: 'center',
            'data-testid': 'fault-code',
            children: [
              {
                op: 'ui',
                name: 'Icon',
                fontSize: '1.25rem',
                icon: 'Warning',
                color: 'warning',
              },
              {
                op: 'ui',
                name: 'FaultSourceDescription',
                eventData: { op: 'context', path: 'item.event.data' },
                thingId: { op: 'context', path: 'item.event.thingId' },
                eventId: { op: 'context', path: 'item.event.eventId' },
              },
            ],
          },
          else: [
            {
              op: 'ui',
              name: 'Typography',
              children: {
                op: 'ui',
                name: 'Stack',
                direction: 'row',
                gap: 1,
                alignItems: 'center',
                'data-testid': 'fault-code',
                children: [
                  {
                    op: 'ui',
                    name: 'Icon',
                    fontSize: '1.25rem',
                    icon: 'Warning',
                    color: 'warning',
                  },
                  {
                    op: 'context',
                    path: 'item.event.data.code',
                  },
                ],
              },
            },
            {
              op: 'ui',
              name: 'Typography',
              variant: 'caption',
              color: 'textSecondary',
              'data-testid': 'failure-mode-identifier',
              children: {
                op: 'if',
                condition: {
                  op: 'ne', a: { op: 'context', path: 'item.event.data.type' }, b: 'Hino',
                },
                then: [
                  'FMI - ',
                  {
                    op: 'context',
                    path: 'item.event.data.failureModeIdentifier',
                  },
                ],
                else: {
                  op: 'context',
                  path: 'item.event.data.faultItem',
                },
              },
            },
          ],
        },
      ],
    },
    {
      op: 'ui',
      name: 'Stack',
      direction: 'row',
      gap: 1,
      flex: '1 0 50%',
      justifyContent: 'right',
      alignItems: 'center',
      children: [
        {
          op: 'ui',
          name: 'Stack',
          children: [
            {
              op: 'ui',
              name: 'Box',
              textAlign: 'right',
              children: [
                {
                  op: 'if',
                  condition: {
                    op: 'ne', a: { op: 'context', path: 'item.event.data.type' }, b: 'Hino',
                  },
                  then: {
                    op: 'ui',
                    name: 'RecommendationLabel',
                    eventData: {
                      op: 'context',
                      path: 'item.event.data',
                    },
                    thingId: {
                      op: 'context',
                      path: 'item.event.thingId',
                    },
                  },
                  else: [
                    {
                      op: 'ui',
                      name: 'Tooltip',
                      title: {
                        op: 'format-timestamp',
                        format: 'mediumWithSeconds',
                        value: {
                          op: 'context',
                          path: 'item.firstEventOccurred',
                        },
                      },
                      children: {
                        op: 'ui',
                        name: 'Typography',
                        component: 'span',
                        color: 'textSecondary',
                        variant: 'caption',
                        'data-testid': 'first-date',
                        children: {
                          op: 'ui',
                          name: 'FormatTimestamp',
                          format: 'timeWithSeconds',
                          value: {
                            op: 'context',
                            path: 'item.firstEventOccurred',
                          },
                        },
                      },
                    },
                    {
                      op: 'ui',
                      name: 'Typography',
                      component: 'span',
                      variant: 'caption',
                      color: 'textSecondary',
                      'data-testid': 'last-date',
                      children: [' - ', {
                        op: 'ui',
                        name: 'Tooltip',
                        title: {
                          op: 'format-timestamp',
                          format: 'mediumWithSeconds',
                          value: {
                            op: 'context',
                            path: 'item.lastEventOccurred',
                          },
                        },
                        children: {
                          op: 'ui',
                          name: 'Box',
                          component: 'span',
                          children: {
                            op: 'if',
                            condition: {
                              op: 'context',
                              path: 'item.isOngoing',
                            },
                            then: [{
                              op: 'translate',
                              translation: 'track:page.history.ongoing.labels',
                            }],
                            else: {
                              op: 'ui',
                              name: 'Box',
                              component: 'span',
                              children: {
                                op: 'ui',
                                name: 'FormatTimestamp',
                                format: 'timeWithSeconds',
                                value: {
                                  op: 'context',
                                  path: 'item.lastEventOccurred',
                                },
                              },
                            },
                          },
                        },
                      }],
                    },
                  ],
                },
              ],
            },
            {
              op: 'ui',
              name: 'Breadcrumbs',
              className: 'journey-breadcrumbs',
              separator: '|',
              children: [
                {
                  op: 'ui',
                  name: 'Typography',
                  variant: 'caption',
                  'data-testid': 'occurrence-count',
                  children: {
                    op: 'translate',
                    translation: 'track:page.history.occurrence.labels',
                    count: {
                      op: 'array-length',
                      value: {
                        op: 'context',
                        path: 'item.originalEvents',
                      },
                    },
                  },
                },
                {
                  op: 'ui',
                  name: 'Typography',
                  variant: 'caption',
                  'data-testid': 'fault-status',
                  color: {
                    op: 'theme-property',
                    path: {
                      op: 'if',
                      condition: {
                        op: 'context',
                        path: 'item.isOngoing',
                      },
                      then: 'palette.error.light',
                      else: 'palette.success.light',
                    },
                  },
                  children: {
                    op: 'translate',
                    translation: {
                      op: 'if',
                      condition: {
                        op: 'context',
                        path: 'item.isOngoing',
                      },
                      then: 'track:page.history.fault-active.labels',
                      else: 'track:page.history.fault-cleared.labels',
                    },
                  },
                },
              ],
            },
          ],
        },
        {
          op: 'ui',
          name: 'Box',
          children: {
            op: 'ui',
            name: 'IconButton',
            size: 'small',
            'data-testid': 'fault-grid-dialog-button',
            onClick: {
              op: 'context',
              path: 'openFaultGridDialog',
            },
            children: {
              op: 'ui',
              name: 'Icon',
              icon: 'Search',
            },
          },
        },
      ],
    }],
  },
  content: {
    op: 'ui',
    name: 'Stack',
    pt: 1,
    spacing: 2,
    children: [
      {
        op: 'context',
        path: 'faultDescription',
      },
    ],
  },
};
